import { render, staticRenderFns } from "./StagingEditorError.vue?vue&type=template&id=007473ad"
import script from "./StagingEditorError.vue?vue&type=script&lang=ts"
export * from "./StagingEditorError.vue?vue&type=script&lang=ts"
import style0 from "./StagingEditorError.vue?vue&type=style&index=0&id=007473ad&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports